// extracted by mini-css-extract-plugin
export default {"base":"Message_base__hsEEs","success":"Message_success__KxHb2","error":"Message_error__yFZBo","warning":"Message_warning__fvxrE"};